import { getToken } from '../../utils/tokenHelper';

// User selectors
export const selectUser = (state) => state.auth?.user;
export const selectIsAuthenticated = (state) => {
  const token = state.auth?.token || getToken();
  return Boolean(state.auth?.isAuthenticated && token);
};
export const selectToken = (state) => state.auth?.token;
export const selectMemberId = (state) => state.auth?.memberId;

// Loading selectors
export const selectLoginLoading = (state) => state.auth?.loginLoading;
export const selectOtpLoading = (state) => state.auth?.otpLoading;
export const selectSignupLoading = (state) => state.auth?.signupLoading;
export const selectProfileLoading = (state) => state.auth?.profileLoading;
export const selectSocialLoginLoading = (state) => state.auth?.socialLoginLoading;
export const selectLogoutLoading = (state) => state.auth?.logoutLoading;
export const selectInitLoading = (state) => state.auth?.initLoading;

// Error selectors
export const selectError = (state) => state.auth?.error;
export const selectLoginError = (state) => state.auth?.loginError;
export const selectOtpError = (state) => state.auth?.otpError;
export const selectSignupError = (state) => state.auth?.signupError;
export const selectProfileError = (state) => state.auth?.profileError;

// OTP flow selectors
export const selectPendingEmail = (state) => state.auth?.pendingEmail;
export const selectIsRegistered = (state) => state.auth?.isRegistered;

// Combined selectors
export const selectAuthState = (state) => ({
  isAuthenticated: state.auth?.isAuthenticated,
  user: state.auth?.user,
  isLoading: state.auth?.initLoading,
});

export const selectLoginState = (state) => ({
  loading: state.auth?.loginLoading,
  error: state.auth?.loginError,
});

export const selectOtpState = (state) => ({
  loading: state.auth?.otpLoading,
  error: state.auth?.otpError,
  pendingEmail: state.auth?.pendingEmail,
  isRegistered: state.auth?.isRegistered,
});

export const selectSignupState = (state) => ({
  loading: state.auth?.signupLoading,
  error: state.auth?.signupError,
});
